import { RECORD_VIEW_CONFIG } from '../constants/records';

/** Keep the current view reachable if its records disappear while it is being read. */
export function getVisibleViews(
  counts: Record<string, number>,
  activeView: string,
  mode: 'available' | 'all' = 'available'
): string[] {
  return Object.keys(RECORD_VIEW_CONFIG).filter(
    key => mode === 'all' || key === 'chat' || key === activeView || counts[key] > 0
  );
}
